import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const WRENCH_MODE_SCHEDULES_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('WRENCH_MODE_SCHEDULES');
export const WRENCH_MODE_SCHEDULES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	WRENCH_MODE_SCHEDULES_CRUD_ACTION_CONSTANTS
);
